import type { RecommendationType } from '../types/RecommendationType';
import type { FilterParams } from '../types/types';

type BrandClubPowerstepParam =
    | FilterParams<'recommendation_type', RecommendationType>
    | FilterParams<'recommendation_name'>
    | FilterParams<'recommendation_index'>
    | FilterParams<'position'>;

export default function getRecommendationParams(label, recommendationType): BrandClubPowerstepParam[] {
    const paramValues = label.split('.');
    const indexAndPositionParamValues = paramValues[1].split(' - ');

    return [
        { param_name: 'recommendation_type', param_value: recommendationType },
        { param_name: 'recommendation_index', param_value: indexAndPositionParamValues[0] },
        { param_name: 'position', param_value: indexAndPositionParamValues[1] }
    ];
}
